import { StyledButton, StyledContent, StyledTitle } from '@/components/styles';
import { ContentSection, Articles, Hero, Breadcrumbs } from '@/components';
import { useLoadMore } from '@/hooks';
import api from '@/lib/api';
import { useTranslation } from 'react-i18next';

export default function BlogPage(props) {
  const { paginator } = props;
  const { banners, meta } = paginator;
  const { t } = useTranslation('global');
  const pageTitle = meta?.h1 || 'OUR NEWS';

  const blogPaginator = useLoadMore(api.articles, paginator);

  const breadcrumbs = [
    {
      id: 1,
      title: t('main.titlePage'),
      slug: '',
      type: 'index',
    },
    {
      id: 2,
      title: pageTitle,
      slug: '',
      type: 'blog',
    },
  ];

  return (
    <>
      {!!banners?.length && <Hero data={banners} size="small" asH1={!h1}/>}
      <StyledContent.Container>
        <StyledContent.BreadcrumbsContainer>
          {breadcrumbs?.length > 0 && <Breadcrumbs items={breadcrumbs} theme="light" />}
        </StyledContent.BreadcrumbsContainer>
      </StyledContent.Container>
      <StyledContent>
        <StyledContent.Container>
          <StyledContent.ColumnMain>
            <StyledContent.Loadable isLoading={blogPaginator.loading}>
              {blogPaginator.items && blogPaginator.items.length > 0 ? (
                <ContentSection noTitle>
                  {!banners?.length &&<StyledTitle size="large" mb="medium" as="h1">{pageTitle}</StyledTitle>}
                  <Articles data={blogPaginator.items} />
                  {blogPaginator.hasMore && (
                  <StyledContent.LoadBtn style={{marginTop:'20px'}}>
                    <StyledButton light onClick={blogPaginator.handleLoadMore}>
                      {t('showMore')}
                    </StyledButton>
                  </StyledContent.LoadBtn>
                   )} 
                </ContentSection>
              ) : (
                <StyledContent.Empty>{t('articles.empty')}</StyledContent.Empty>
              )}
            </StyledContent.Loadable>
          </StyledContent.ColumnMain>
        </StyledContent.Container>
      </StyledContent>
    </>
  );
}
